// DS: P20
// @dynamic-i18n-keys
// Dynamic t() at line 48: labelTransKey from ternary (isPaidFolder / isWatchToAccess).
//   folderCard.badge.premium
//   folderCard.badge.watchers
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiPremiumFolderData } from '@wix/da-papi-types';
import classnames from 'classnames';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import PremiumGalleryIcon from '@wix/da-ds/pkg/Icons/16x16/PremiumGallery';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';

import s from './FolderRibbon.scss';

export interface Props {
  premiumFolderData?: PapiPremiumFolderData;
  className?: string;
}

const FolderRibbon: React.FC<Props> = ({ premiumFolderData, className }) => {
  const { t } = useTranslation();

  const { isPremium, isPaidFolder, isWatchToAccess } =
    normalizePremiumFolderData(premiumFolderData);

  if (!isPremium) {
    return null;
  }

  let labelTransKey;
  if (isPaidFolder) {
    labelTransKey = 'folderCard.badge.premium';
  } else if (isWatchToAccess) {
    labelTransKey = 'folderCard.badge.watchers';
  } else {
    // we don't know what it is. if only we knew what it is... but we don't know.
    return null;
  }

  return (
    <div
      className={classnames(
        s['root'],
        isPaidFolder && s['premium'],
        isWatchToAccess && s['watchers'],
        className
      )}
    >
      {isPaidFolder && <PremiumGalleryIcon className={s['icon']} />}
      {isWatchToAccess && <FollowingWatchIcon className={s['icon']} />}
      <span className={s['title']}>{t(labelTransKey)}</span>
    </div>
  );
};
FolderRibbon.displayName = 'FolderRibbon';

export default FolderRibbon;
